import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from '../../../../../store/store';
import { getJobsThunk } from '../../../../../store/workspace/thunks';
import { selectSelectedJob } from '../../../../../store/workspace/selectors';
import { endExamThunk } from '../../../../../store/workspace/thunks';
import styles from './style.module.scss';
import { setEditJobExamDeadlineModal, setSelectedJob } from '../../../../../store/workspace/slice';
import { setNotification } from '../../../../../store/general/slice';
import Modal from '../../../../../components/Modal';
import { EditSquareIcon } from '../../../../../assets/icons';
import Button from '../../../../../components/Button';
import CustomCalendar from '../../../../../components/Calendar';
import { formatDate, fromDatePickerFormat, toDatePickerFormat } from '../../../../../utils/dateHelpers';
import { DayValue } from '@amir04lm26/react-modern-calendar-date-picker';

export default function EditJobExamDeadline() {
    const dispatch = useDispatch();
    const job = useSelector(selectSelectedJob);
    const [loading, setLoading] = useState(false);
    const [deadline, setDeadline] = useState<DayValue>();

    useEffect(() => {
        if (!job) return;
        setDeadline(toDatePickerFormat(job.multipleChoiceExamDeadline));
    }, [job]);

    const endExam = () => {
        if (!job || !deadline) return;
        setLoading(true);

        dispatch(endExamThunk({
            endDate: fromDatePickerFormat(deadline),
            id: job.id,
            action: 'edit',
        }))
            .unwrap()
            .then(() => {
                dispatch(getJobsThunk({}));
                dispatch(setSelectedJob(null));
                dispatch(setEditJobExamDeadlineModal(false));
                dispatch(setNotification(['Job updated successfully', 'success']));
            })
            .catch(() => {
                dispatch(setNotification(['Something went wrong,Try again...', 'error']));
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <Modal
            size='sm'
            icon={<EditSquareIcon />}
            title='Update exam deadline'
            childClassName={styles.wrapper}
            closeFunc={() => dispatch(setEditJobExamDeadlineModal(false))}
        >
            <CustomCalendar
                selectedDate={deadline}
                setSelectedDate={setDeadline}
                minimumDate={toDatePickerFormat(formatDate(new Date())) || undefined}
            />
            <div className={styles.action}>
                <Button
                    className={styles.action_btn}
                    type='Outline-Dark'
                    text='Cancel'
                    onClick={() => dispatch(setEditJobExamDeadlineModal(false))}
                />
                <Button
                    className={styles.action_btn}
                    loading={loading}
                    type='Primary'
                    text='Update'
                    onClick={endExam}
                    disabled={!deadline || !job}
                />
            </div>
        </Modal>
    )
}
